import Vue from 'vue'
import Router from 'vue-router'
const Main = () => import('@/views/main.vue')
const wapMain = () => import('@/views/wapmain.vue')
const Source = () => import('@/views/Source.vue')
const Myarticle = () => import('@/views/Myarticle.vue')
const Mainhomepage = () => import('@/views/Mainhomepage.vue')//编辑首页
const Topicreview = () => import('@/views/Topicreview.vue')//选题管理（主编）
const outline = () => import('@/views/outline.vue')//提纲（主编）
const Mainwrite = () => import('@/views/Mainwrite.vue')//写作（主编）
const Membermanagement = () => import('@/views/Membermanagement.vue')//成员管理（主编）
const Edithomepage = () => import('@/views/Edithomepage.vue')//编辑首页
const TopicsList = () => import('@/views/TopicsList.vue')//选题列表（小编）
const Editorwrite = () => import('@/views/Editorwrite.vue')//写作列表（小编）
const Dataanalysis = () => import('@/views/Dataanalysis.vue') //数据分析（小编）
const WriterTopicsList = () => import('@/views/WriterTopicsList.vue') //选题列表（写手）
const Articlewrite = () => import('@/views/Articlewrite.vue') //订单列表（写手）
const writeList = () => import('@/views/writeList.vue') //写作列表（写手）
const AccountSet = () => import('@/views/AccountSet.vue') //账号设置（写手）
const Mywriter = () => import('@/views/Mywriter.vue') //我的写手（城市管理员）
const wardenincome = () => import('@/views/wardenincome.vue') //文章数据（城市管理员）
const Createaccount = () => import('@/views/Createaccount.vue')//创建账号（运营）
const Contentdata = () => import('@/views/Contentdata.vue')//内容数据（主编）
const Crowdsouredata = () => import('@/views/Crowdsouredata.vue')//众包数据（主编）
const Twodata = () => import('@/views/Twocreatedata.vue') //二创数据（主编）
const Secondreport = () => import('@/views/Secondreport.vue') //二创报表（主编）
const Writeranalysis = () => import('@/views/Writeranalysis.vue') //数据分析（写手）
const Writerincome = () => import('@/views/Writerincome.vue') //写手收益（写手）
const Operationaldata = () => import('@/views/Operationaldata.vue')  //数据（运营）
const partnership = () => import('@/views/partnership.vue')   //管理员数据（运营）
const Operatewrite = () => import('@/views/Operatewrite.vue')  //写手数据（运营）
const Articlereview = () => import('@/views/Articlereview.vue')  //文章(主编)
//-----------权限管理----------
const MenuManagement = () => import('@/views/MenuManagement.vue')  //菜单管理
const UserManagement = () => import('@/views/UserManagement.vue')  //用户管理
const RoleManagement = () => import('@/views/RoleManagement.vue')  //角色管理
const UrlManagement = () => import('@/views/UrlManagement.vue')  //url管理

const Login = () => import('@/views/login.vue')  //登陆页面
const contentAnalysis = () => import('@/views/Selfmedia/contentAnalysis')  //自媒体帐号数据
const accountnumber = () => import('@/views/Selfmedia/accountnumber')  //帐号管理
const Editor = () => import('@/components/Editor/Editor')  //富文本
const Mcnregister = () => import('@/views/Mcnregister')  //注册页面
const help = () => import('@/views/help')  //帮助页面
const contentPush = () => import('@/views/contentPush')  //二创原文
const Specialcolumn = () => import('@/views/Specialcolumn')  //二创专栏管理

//联运后台模块
const openaccount = () => import('@/views/Getfunion/openaccount.vue')  //邀请开户
const Userlist = () => import('@/views/Getfunion/Userlist.vue')   //用户列表
const Incomedata = () => import('@/views/Getfunion/Incomedata.vue')   //收益数据
const Userincome = () => import('@/views/Getfunion/Userincome.vue')   //用户收益
const Infoaudit = () => import('@/views/Getfunion/Infoaudit.vue')   //信息审核
const postalcash = () => import('@/views/Getfunion/postalcash.vue')   //提现管理
const Profitstatement = () => import('@/views/Getfunion/Profitstatement.vue')   //利润报表
const mediaread = () => import('@/views/Getfunion/mediaread.vue')   //自媒体阅读量
const Manufacturerread = () => import('@/views/Getfunion/Manufacturerread.vue')   //厂商阅读量
const parameterset = () => import('@/views/Getfunion/parameterset.vue')   //参数调节
const Contentsource = () => import('@/views/Getfunion/Contentsource.vue')  //联运文库

import store from '../store/store'
import * as types from '../store/types'

//二创
const library = () => import('@/views/library.vue') 
const Receivetask = () => import('@/views/Receivetask.vue')  
const Twocreateaudit = () => import('@/views/Twocreateaudit.vue')  

//编译内容
const Compilelibrary = () => import('@/views/compile/compilelibrary.vue') 
const Compileaudit = () => import('@/views/compile/compileaudit.vue') 
const Compilecreate = () => import('@/views/Compilecreate.vue') 

//百度统计数据可视化
const toppage = () => import('@/views/tongji/toppage.vue') 

//图库
const upload = () => import('@/views/mapdepot/upload.vue') //上传图片
const examine = () => import('@/views/mapdepot/examine.vue') //审核图片
const turnoff = () => import('@/views/mapdepot/turnoff.vue') //成品图库

//铃声
const MusicRBT = () => import('@/views/Music/Music_RBT.vue')
//发布
const Publish = () => import('@/views/Publish/Autopublish')//图文发布
const VideoPublish = () => import('@/views/Publish/Videopublish')//视频图文
const PicturePublish = () => import('@/views/Publish/PicturePublish')//图片
const PicturePublishNoRealate = () => import('@/views/Publish/PicturePublishNoRealate')//图片

//京东问答圈子
const QAsource = () => import('@/views/JDCircle/QAsource')//问答信源及审核
const Answereply = () => import('@/views/JDCircle/Answereply')//问答领取及创作回复
const Dynamicsource = () => import('@/views/JDCircle/Dynamicsource')//动态信源 
const Dynamicreceive = () => import('@/views/JDCircle/Dynamicreceive')//动态领取 
const Articlelist = () => import('@/views/JDCircle/Articlelist')//京东图文内容管理
const Videolist = () => import('@/views/JDCircle/Videolist')//京东视频内容管理
const Commentsource = () => import('@/views/JDCircle/Commentsource')//京东评论信源
const Commentreceive = () => import('@/views/JDCircle/Commentreceive')//京东评论领取

//综合视频内容管理
const uploadvideo = () => import('@/views/Videomanagement/uploadvideo')//视频内容上传
const Videomanagementlist = () => import('@/views/Videomanagement/videoList')//视频管理list
//---------临时增加图文信源审核发布到华为页面------------
const VideomanageArticlelist=()=>import('@/views/Videomanagement/ArticleList')//图文管理
//error-page
const error_404 = () => import('@/views/errorPage/404Page')//找不到页面
const error_401 = () => import('@/views/errorPage/401Page')//暂无权限访问

//自动发布管理
// import Contentaudit from '@/views/Releasemanagement/OldContentaudit'//内容审核（旧）
const Contentaudit = () => import('@/views/Releasemanagement/NewContentaudit')//内容审核（新）
const AddPublishInfo = () => import('@/views/Releasemanagement/AddPublishInfo')//内容审核（新）

//大河审核
const Dahecontentaudit = () => import('@/views/Daheaudit/contentaudit')//大河图文审核

//签约作者
const personalinfo = () => import('@/views/Contractrauthor/personalinfo')//个人信息
const Contentpublish = () => import('@/views/Contractrauthor/Contentpublish')//内容发布
const Contentmanage = () => import('@/views/Contractrauthor/Contentmanage') //内容管理
const contentoverall = () => import('@/views/Contractrauthor/analysis/content-overall') //内容数据
const incomeoverview = () => import('@/views/Contractrauthor/analysis/income-overview') //收益数据
import {
  myInfo,
  myMenus
} from '../api'
Vue.use(Router)
// cookie，重新赋值token
var getCookie = function (name) {
  var arr;
  var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return unescape(arr[2]);
  else
    return null;
};
if (getCookie('token') != null && getCookie('token') != '') {
  store.commit(types.LOGIN_IN, getCookie('token'))
}

const routes = [{
    path: '/',
    redirect: '/Login'
  },
  {
    path: '/wapContentProduction',
    redirect: '/Login',
    name: '选题系统',
    component:  wapMain,
    children: [{
        path: '/wapContentProduction/contentProduction',
        redirect: '/Login',
        name: '内容生产系统',
        component: Main,
        children: [{
            path: '/wapContentProduction/contentProduction/help',
            component: help,
            name: '帮助',
            menuShow: true
          },
          {
            path: '/wapContentProduction/contentProduction/Mainhomepage',
            component: Mainhomepage,
            name: '主编首页',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/source',
            component: Source,
            name: '信源',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Myarticle',
            component: Myarticle,
            name: '我的文章',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Topicreview',
            component: Topicreview,
            name: '选题管理',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/outline',
            component: outline,
            name: '提纲',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Mainwrite',
            component: Mainwrite,
            name: '写作列表（主编）',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/AutoPublish',
            component: Publish,
            name: '发布',
            menuShow: true,
            meta: {
              requireAuth: true,
              keepAlive: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/ContentPublish',
            component: Publish,
            name: '内容发布',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/VideoPublish',
            component: VideoPublish,
            name: '视频发布',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/picturePublishNoRealate',
            component: PicturePublishNoRealate,
            name: '添加图片',
            menuShow: false,
            meta: {
              requireAuth: false,
            }
          },
          {
            path: '/wapContentProduction/contentProduction/picturePublish',
            component: PicturePublish,
            name: '图片发布',
            menuShow: true,
            meta: {
              requireAuth: true,
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Contentaudit',
            component: Contentaudit,
            name: '内容审核',
            menuShow: true,
            meta: {
              requireAuth: true,
              keepAlive: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/addPublishInfo',
            component: AddPublishInfo,
            name: '添加发布信息',
            menuShow: false,
            meta: {
              requireAuth: false,
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Contentaudit2',
            component: Contentaudit,
            name: '内容审核2',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/ArticlePublish',
            component: Publish,
            name: '一键发布',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/library',
            component: library,
            name: 'library',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Specialcolumn',
            component: Specialcolumn,
            name: 'Specialcolumn',
            menuShow: true
          },
          {
            path: '/wapContentProduction/contentProduction/Twocreateaudit',
            component: Twocreateaudit,
            name: '二创审核',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Compilelibrary',
            component: Compilelibrary,
            name: '编辑文库',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Compileaudit',
            component: Compileaudit,
            name: '编译审核',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Membermanagement',
            component: Membermanagement,
            name: '成员管理',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Dataanalysis',
            component: Dataanalysis,
            name: '数据分析（小编）',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Edithomepage',
            component: Edithomepage,
            name: '编辑首页',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/TopicsList',
            component: TopicsList,
            name: '选题列表',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Editorwrite',
            component: Editorwrite,
            name: '写作列表',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/WriterTopicsList',
            component: WriterTopicsList,
            name: '选题列表(写手)',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Articlewrite',
            component: Articlewrite,
            name: '订单列表',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/writeList',
            component: writeList,
            name: '写作列表(写手)',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Receivetask',
            component: Receivetask,
            name: '写手领取二次图文',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Compilecreate',
            component: Compilecreate,
            name: '写手海外编译创作',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/AccountSet',
            component: AccountSet,
            name: '账号设置（写手）',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Articlereview',
            component: Articlereview,
            name: '文章审核',
            menuShow: true,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/MenuManagement',
            name: '菜单管理',
            component: MenuManagement,
            meta: {
              title: '菜单管理',
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/UserManagement',
            name: '用户管理',
            component: UserManagement,
            meta: {
              title: '用户管理',
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/RoleManagement',
            name: '角色管理',
            component: RoleManagement,
            meta: {
              title: '角色管理',
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/UrlManagement',
            name: 'url管理',
            component: UrlManagement,
            meta: {
              title: 'url管理',
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Selfmedia/contentAnalysis',
            name: '自媒体内容分析',
            component: contentAnalysis,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Selfmedia/accountnumber',
            name: '自媒体账号管理',
            component: accountnumber,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Editor',
            name: '富文本编辑器',
            component: Editor,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Mywriter',
            name: '我的写手',
            component: Mywriter,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Createaccount',
            name: '创建账号',
            component: Createaccount,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Contentdata',
            name: '内容数据',
            component: Contentdata,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Crowdsouredata',
            name: '众包数据',
            component: Crowdsouredata,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Twocreatedata',
            name: '二创数据',
            menuShow: true,
            component: Twodata,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Secondreport',
            name: '二创报表',
            menuShow: true,
            component: Secondreport,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Writeranalysis',
            name: '写手分析',
            component: Writeranalysis,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Writerincome',
            name: '写手收益',
            component: Writerincome,
            meta: {
              requireAuth: true
            }

          },
          {
            path: '/wapContentProduction/contentProduction/Operationaldata',
            name: '运营所看数据',
            component: Operationaldata,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/partnership',
            name: '合伙管理员数据',
            component: partnership,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Operatewrite',
            name: '运营所看写手数据',
            component: Operatewrite,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/wardenincome',
            name: '管理员收益数据',
            component: wardenincome,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Getfunionopenaccount',
            name: '联运后台-邀请开户',
            component: openaccount,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/GetfunionUserlist',
            name: '联运后台-用户列表',
            component: Userlist,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/GetfunionInfoaudit',
            name: '联运后台-信息审核',
            component: Infoaudit,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/GetfunionIncomedata',
            name: '联运后台-收益数据',
            component: Incomedata,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Userincome',
            name: '联运后台-用户收益',
            component: Userincome,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/postalcash',
            name: '联运后台-提现管理',
            component: postalcash,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Profitstatement',
            name: '联运后台-利润报表',
            component: Profitstatement,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/mediaread',
            name: '联运后台-自媒体阅读量',
            component: mediaread,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Manufacturerread',
            name: '联运后台-厂商阅读量',
            component: Manufacturerread,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/parameterset',
            name: '联运后台-参数调节',
            component: parameterset,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Contentsource',
            name: '联运-文库',
            component: Contentsource,
            meta: {
              requireAuth: true
            }
          },
          //图库
          {
            path: '/wapContentProduction/mapdepot/upload',
            name: '图库-上传图片',
            component: upload,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/mapdepot/examine',
            name: '图库-上传管理',
            component: examine,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/mapdepot/turnoff',
            name: '图库-素材管理',
            component: turnoff,
            meta: {
              requireAuth: true
            }
          },
          //京东圈子-问答信源
          {
            path: '/wapContentProduction/contentProduction/QAsource',
            name: '京东圈子-问答信源',
            component: QAsource,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Answereply',
            name: '京东圈子-问答回复',
            component: Answereply,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Dynamicsource',
            name: '京东圈子-动态信源',
            component: Dynamicsource,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Dynamicreceive',
            name: '京东圈子-动态领取',
            component: Dynamicreceive,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Articlelist',
            name: '京东图文内容管理',
            component: Articlelist,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Videolist',
            name: '京东视频内容管理',
            component: Videolist,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Commentsource',
            name: '京东评论信源',
            component: Commentsource,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/contentProduction/Commentreceive',
            name: "京东评论领取",
            component: Commentreceive,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/Videomanagement/uploadvideo',
            name: '上传视频内容',
            component: uploadvideo,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/Videomanagement/videoList',
            name: '视频管理List',
            component: Videomanagementlist,
            meta: {
              requireAuth: true
            }
          },
          {
            path:'/wapContentProduction/Videomanagement/ArticleList',
            name:'图文管理List',
            component:VideomanageArticlelist,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/wapContentProduction/error_404',
            name: '404',
            component: error_404,
            meta: {
              title: '404'
            }
          },
          {
            path: '/wapContentProduction/error_401',
            name: '401',
            component: error_401,
            meta: {
              title: '401'
            }
          },
        ]
      },
      {
        path: '/wapContentProduction/tongji',
        name: '百度统计',
        component: Main,
        redirect: '/wapContentProduction/tongji/toppage',
        children: [{
          path: '/wapContentProduction/tongji/toppage',
          component: toppage,
          name: '访问概况',
          menuShow: true
        }]
      },
      {
        path: '/wapContentProduction/Dahetaudit',
        name: '大河审核',
        component: Main,
        redirect: '/wapContentProduction/Dahetaudit/contentaudit',
        children: [{
          path: '/wapContentProduction/Dahetaudit/contentaudit',
          component: Dahecontentaudit,
          name: '大河图文审核',
          menuShow: true,
          meta: {
            requireAuth: true
          }
        }]
      },{
        path: '/wapContentProduction/Contractrauthor',
        name: '签约作者',
        component: Main,
        redirect: '/wapContentProduction/Contractrauthor/personalinfo',
        children: [{
          path: '/wapContentProduction/Contractrauthor/personalinfo',
          component: personalinfo,
          name: '签约作者个人信息',
          menuShow: true
          // meta: {
          //   requireAuth: true
          // }
        }, {
          path: '/wapContentProduction/Contractrauthor/Contentpublish',
          component: Contentpublish,
          name: '签约作者-内容发布',
          menuShow: true
          // meta: {
          //   requireAuth: true
          // }
        }, {
          path: '/wapContentProduction/Contractrauthor/Contentmanage',
          component: Contentmanage,
          name: '签约作者-内容管理',
          menuShow: true
          // meta: {
          //   requireAuth: true
          // }
        }, {
          path: '/wapContentProduction/Contractrauthor/analysis/contentoverall',
          component: contentoverall,
          name: '签约作者-内容数据',
          menuShow: true
        }, {
          path: '/wapContentProduction/Contractrauthor/analysis/incomeoverview',
          component: incomeoverview,
          name: '签约作者-收益数据',
          menuShow: true
        }]
      }
    ]
  },
  {
    path: '/Login',
    name: 'MCN系统登录',
    component: Login,
    meta: {
      title: 'MCN系统登录'
    }
  },
  {
    path: '/Mcnregister',
    name: 'MCN系统帐号注册',
    component: Mcnregister,
    meta: {
      title: 'MCN系统帐号注册'
    }
  },
  {
    path: '/wapContentProduction/contentProduction/contentPush',
    component: contentPush,
    name: '二创内链',
    menuShow: true
  },
  {
    path: '/Music_RBT',
    name: '彩铃列表',
    component: MusicRBT,
    meta: {
      title: '彩铃列表'
    }
  },
  {
    path: '*',
    redirect: '/wapContentProduction/error_404'
  }
]
const router = new Router({
  mode: 'history',
  routes
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.requireAuth)) {
    if (store.state.token != null && store.state.token !== '') {
      myInfo().then(res => {
        sessionStorage.setItem("userId", res.data.id);
        sessionStorage.setItem("userName", res.data.nickName);
        sessionStorage.setItem("roleVos", JSON.stringify(res.data.roleVos));
        if (!res.needCompleteInfo) {
          myMenus().then(res => {
              if (res.length != "0") {
                if (JSON.stringify(res).indexOf(to.path) == "-1") {
                  next({
                    path: '/wapContentProduction/error_401'
                  })
                } else {
                  next();
                }
              } else {
                next({
                  path: '/wapContentProduction/error_401'
                })
              }
            })
            .catch(error => {
              if (String(error).indexOf('timeout') == -1) {
                next({
                  path: '/Login'
                })
              }
            });
        } else {
          this.$router.push({
            path: "/Mcnregister?activestep=2"
          });
        }
      }).catch(error => {
        if (String(error).indexOf('timeout') == -1) {
          next({
            path: '/Login'
          })
        }
      })
    } else {
      next({
        path: '/Login'
      })
    }
  } else {
    next();
  }
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js